/// <amd-module name="SuiteCommerce.PagePrinter.ExtQRCode.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.PagePrinter.ExtQRCode.Model", ["require", "exports", "Backbone", "SuiteCommerce.PagePrinter.ExtQRCode.Utils", "SuiteCommerce.PagePrinter.ExtQRCode.RSBlock", "SuiteCommerce.PagePrinter.ExtQRCode.BitBuffer", "SuiteCommerce.PagePrinter.ExtQRCode.Polynomial", "SuiteCommerce.PagePrinter.ExtQRCode.Byte"], function (require, exports, Backbone_1, Utils_1, RSBlock_1, BitBuffer_1, Polynomial_1, Byte_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var BuildingMode;
    (function (BuildingMode) {
        BuildingMode[BuildingMode["Testing"] = 0] = "Testing";
        BuildingMode[BuildingMode["Release"] = 1] = "Release";
    })(BuildingMode || (BuildingMode = {}));
    var QRCodeModel = /** @class */ (function (_super) {
        __extends(QRCodeModel, _super);
        function QRCodeModel(options) {
            var _this = _super.call(this, options) || this;
            _this.exponentialTable = [];
            _this.logarithmTable = [];
            _this.type = options.type;
            _this.bytes = [];
            _this.errorCorrectLevel = options.errorCorrectLevel;
            _this.moduleCount = _this.type * 4 + 17;
            _this.dataCache = [];
            _this.bytes.push(new Byte_1.Byte(options.data));
            _this.populateOperationTables();
            _this.buildModules(BuildingMode.Release, _this.getBestMaskPattern());
            return _this;
        }
        QRCodeModel.prototype.populateOperationTables = function () {
            for (var i = 0; i < 8; i++) {
                this.exponentialTable[i] = 1 << i;
            }
            for (var i = 8; i < 256; i++) {
                this.exponentialTable[i] =
                    this.exponentialTable[i - 4] ^
                        this.exponentialTable[i - 5] ^
                        this.exponentialTable[i - 6] ^
                        this.exponentialTable[i - 8];
            }
            for (var i = 0; i < 255; i++) {
                this.logarithmTable[this.exponentialTable[i]] = i;
            }
        };
        QRCodeModel.prototype.buildModules = function (mode, maskPattern) {
            this.modules = new Array(this.moduleCount);
            for (var row = 0; row < this.moduleCount; row++) {
                this.modules[row] = new Array(this.moduleCount);
                for (var col = 0; col < this.moduleCount; col++) {
                    this.modules[row][col] = null;
                }
            }
            this.setupPositionTestingPattern(0, 0);
            this.setupPositionTestingPattern(this.moduleCount - 7, 0);
            this.setupPositionTestingPattern(0, this.moduleCount - 7);
            this.setupPositionAdjustingPattern();
            this.setupTimingPattern();
            this.setupPattern(mode, maskPattern);
            if (this.type >= 7) {
                this.setupType(mode);
            }
            if (this.dataCache.length === 0) {
                this.dataCache = this.generateData(this.type, this.errorCorrectLevel, this.bytes);
            }
            this.mapDataWithPattern(this.dataCache, maskPattern);
        };
        QRCodeModel.prototype.setupPositionTestingPattern = function (row, column) {
            for (var rowPos = -1; rowPos <= 7; rowPos++) {
                if (row + rowPos <= -1 || this.moduleCount <= row + rowPos)
                    continue;
                for (var columnPos = -1; columnPos <= 7; columnPos++) {
                    if (column + columnPos <= -1 || this.moduleCount <= column + columnPos)
                        continue;
                    this.modules[row + rowPos][column + columnPos] =
                        (0 <= rowPos && rowPos <= 6 && (columnPos == 0 || columnPos == 6)) ||
                            (0 <= columnPos && columnPos <= 6 && (rowPos == 0 || rowPos == 6)) ||
                            (2 <= rowPos && rowPos <= 4 && 2 <= columnPos && columnPos <= 4);
                }
            }
        };
        QRCodeModel.prototype.setupPositionAdjustingPattern = function () {
            var position = Utils_1.Utils.getPatternPosition(this.type);
            for (var i = 0; i < position.length; i++) {
                for (var j = 0; j < position.length; j++) {
                    var row = position[i];
                    var column = position[j];
                    if (this.modules[row][column] != null) {
                        continue;
                    }
                    for (var rowPos = -2; rowPos <= 2; rowPos++) {
                        for (var colPos = -2; colPos <= 2; colPos++) {
                            this.modules[row + rowPos][column + colPos] =
                                rowPos == -2 ||
                                    rowPos == 2 ||
                                    colPos == -2 ||
                                    colPos == 2 ||
                                    (rowPos == 0 && colPos == 0);
                        }
                    }
                }
            }
        };
        QRCodeModel.prototype.setupTimingPattern = function () {
            for (var row = 8; row < this.moduleCount - 8; row++) {
                if (this.modules[row][6] != null) {
                    continue;
                }
                this.modules[row][6] = row % 2 == 0;
            }
            for (var column = 8; column < this.moduleCount - 8; column++) {
                if (this.modules[6][column] != null) {
                    continue;
                }
                this.modules[6][column] = column % 2 == 0;
            }
        };
        QRCodeModel.prototype.setupPattern = function (mode, maskPattern) {
            var mask = (this.errorCorrectLevel << 3) | maskPattern;
            var bits = Utils_1.Utils.getBCHTypeInfo(mask);
            for (var i = 0; i < 15; i++) {
                var mod = mode === BuildingMode.Release && ((bits >> i) & 1) == 1;
                if (i < 6) {
                    this.modules[i][8] = mod;
                }
                else if (i < 8) {
                    this.modules[i + 1][8] = mod;
                }
                else {
                    this.modules[this.moduleCount - 15 + i][8] = mod;
                }
            }
            for (var i = 0; i < 15; i++) {
                var mod = mode === BuildingMode.Release && ((bits >> i) & 1) == 1;
                if (i < 8) {
                    this.modules[8][this.moduleCount - i - 1] = mod;
                }
                else if (i < 9) {
                    this.modules[8][15 - i - 1 + 1] = mod;
                }
                else {
                    this.modules[8][15 - i - 1] = mod;
                }
            }
            this.modules[this.moduleCount - 8][8] = mode === BuildingMode.Release;
        };
        QRCodeModel.prototype.setupType = function (mode) {
            var bits = Utils_1.Utils.getBCHIdentifier(this.type);
            for (var i = 0; i < 18; i++) {
                this.modules[Math.floor(i / 3)][(i % 3) + this.moduleCount - 8 - 3] =
                    mode === BuildingMode.Release && ((bits >> i) & 1) == 1;
            }
            for (var i = 0; i < 18; i++) {
                this.modules[(i % 3) + this.moduleCount - 8 - 3][Math.floor(i / 3)] =
                    mode === BuildingMode.Release && ((bits >> i) & 1) == 1;
            }
        };
        QRCodeModel.prototype.mapDataWithPattern = function (data, maskPattern) {
            var inc = -1;
            var row = this.moduleCount - 1;
            var bitIndex = 7;
            var byteIndex = 0;
            for (var col = this.moduleCount - 1; col > 0; col -= 2) {
                if (col == 6)
                    col--;
                while (true) {
                    for (var colPos = 0; colPos < 2; colPos++) {
                        if (this.modules[row][col - colPos] == null) {
                            var isDarkBlock = false;
                            if (byteIndex < data.length) {
                                isDarkBlock = ((data[byteIndex] >>> bitIndex) & 1) == 1;
                            }
                            var mask = Utils_1.Utils.getMask(maskPattern, row, col - colPos);
                            if (mask) {
                                isDarkBlock = !isDarkBlock;
                            }
                            this.modules[row][col - colPos] = isDarkBlock;
                            bitIndex--;
                            if (bitIndex == -1) {
                                byteIndex++;
                                bitIndex = 7;
                            }
                        }
                    }
                    row += inc;
                    if (row < 0 || this.moduleCount <= row) {
                        row -= inc;
                        inc = -inc;
                        break;
                    }
                }
            }
        };
        QRCodeModel.prototype.getBestMaskPattern = function () {
            var minLostPoint = 0;
            var pattern = 0;
            for (var i = 0; i < 8; i++) {
                this.buildModules(BuildingMode.Testing, i);
                var lostPoint = Utils_1.Utils.getLostPoint(this);
                if (i == 0 || minLostPoint > lostPoint) {
                    minLostPoint = lostPoint;
                    pattern = i;
                }
            }
            return pattern;
        };
        QRCodeModel.prototype.generateData = function (type, errorCorrectLevel, dataList) {
            var rsBlocks = RSBlock_1.RSBlock.getRSBlocks(type, errorCorrectLevel);
            var buffer = new BitBuffer_1.BitBuffer();
            for (var i = 0; i < dataList.length; i++) {
                var byte = dataList[i];
                buffer.put(byte.mode, 4);
                buffer.put(byte.length(), Utils_1.Utils.getLengthInBits(type));
                byte.write(buffer);
            }
            var totalDataCount = 0;
            for (var i = 0; i < rsBlocks.length; i++) {
                totalDataCount += rsBlocks[i].dataCount;
            }
            if (buffer.getSizeInBits() + 4 <= totalDataCount * 8) {
                buffer.put(0, 4);
            }
            while (buffer.getSizeInBits() % 8 != 0) {
                buffer.putBit(false);
            }
            while (true) {
                if (buffer.getSizeInBits() >= totalDataCount * 8) {
                    break;
                }
                buffer.put(Utils_1.PAD0, 8);
                if (buffer.getSizeInBits() >= totalDataCount * 8) {
                    break;
                }
                buffer.put(Utils_1.PAD1, 8);
            }
            return this.createBytes(buffer, rsBlocks);
        };
        QRCodeModel.prototype.createBytes = function (buffer, rsBlocks) {
            var offset = 0;
            var maxDcCount = 0;
            var maxEcCount = 0;
            var dcData = new Array(rsBlocks.length);
            var ecData = new Array(rsBlocks.length);
            for (var rsIndex = 0; rsIndex < rsBlocks.length; rsIndex++) {
                var dcCount = rsBlocks[rsIndex].dataCount;
                var ecCount = rsBlocks[rsIndex].totalCount - dcCount;
                maxDcCount = Math.max(maxDcCount, dcCount);
                maxEcCount = Math.max(maxEcCount, ecCount);
                dcData[rsIndex] = new Array(dcCount);
                for (var i = 0; i < dcData[rsIndex].length; i++) {
                    dcData[rsIndex][i] = 0xff & buffer.buffer[i + offset];
                }
                offset += dcCount;
                var rsPoly = Utils_1.Utils.getErrorCorrectPolynomial(ecCount, this);
                var rawPoly = new Polynomial_1.Polynomial(dcData[rsIndex], rsPoly.coefficients.length - 1);
                var modPoly = rawPoly.mod(rsPoly, this);
                ecData[rsIndex] = new Array(rsPoly.coefficients.length - 1);
                for (var i = 0; i < ecData[rsIndex].length; i++) {
                    var modIndex = i + modPoly.coefficients.length - ecData[rsIndex].length;
                    ecData[rsIndex][i] =
                        modIndex >= 0 ? modPoly.getCoefficient(modIndex) : 0;
                }
            }
            var totalCodeCount = 0;
            for (var i = 0; i < rsBlocks.length; i++) {
                totalCodeCount += rsBlocks[i].totalCount;
            }
            var data = new Array(totalCodeCount);
            var index = 0;
            for (var i = 0; i < maxDcCount; i++) {
                for (var r = 0; r < rsBlocks.length; r++) {
                    if (i < dcData[r].length) {
                        data[index++] = dcData[r][i];
                    }
                }
            }
            for (var i = 0; i < maxEcCount; i++) {
                for (var r = 0; r < rsBlocks.length; r++) {
                    if (i < ecData[r].length) {
                        data[index++] = ecData[r][i];
                    }
                }
            }
            return data;
        };
        QRCodeModel.prototype.isDarkBlock = function (row, col) {
            return this.modules[row][col];
        };
        QRCodeModel.prototype.getModuleQuantity = function () {
            return this.moduleCount;
        };
        QRCodeModel.prototype.getLogarithm = function (index) {
            if (index < 1) {
                throw new Error('Logarithm not found');
            }
            return this.logarithmTable[index];
        };
        QRCodeModel.prototype.getExponential = function (index) {
            while (index < 0) {
                index += 255;
            }
            while (index >= 256) {
                index -= 255;
            }
            return this.exponentialTable[index];
        };
        return QRCodeModel;
    }(Backbone_1.Model));
    exports.QRCodeModel = QRCodeModel;
});
